export enum HubspotEnrichmentJobStatusEnum {
  QUEUED = 'queued',
  ANALYZING = 'analyzing',
  REPORT_READY = 'report-ready',
  WRITING_RESULTS = 'writing-results',
  COMPLETE = 'complete',
  FAILED = 'failed',
  ROLLING_BACK = 'rolling-back',
  ROLLED_BACK = 'rolled-back',
  ROLLBACK_FAILED = 'rollback-failed',
  CANCELLED = 'cancelled',
}

export const HubspotEnrichmentJobStatusLabels: Record<HubspotEnrichmentJobStatusEnum, string> = {
  [HubspotEnrichmentJobStatusEnum.QUEUED]: 'Queued',
  [HubspotEnrichmentJobStatusEnum.ANALYZING]: 'Analyzing',
  [HubspotEnrichmentJobStatusEnum.REPORT_READY]: 'Report Ready',
  [HubspotEnrichmentJobStatusEnum.WRITING_RESULTS]: 'Writing Results',
  [HubspotEnrichmentJobStatusEnum.COMPLETE]: 'Completed',
  [HubspotEnrichmentJobStatusEnum.FAILED]: 'Failed',
  [HubspotEnrichmentJobStatusEnum.ROLLING_BACK]: 'Rolling Back',
  [HubspotEnrichmentJobStatusEnum.ROLLED_BACK]: 'Rolled Back',
  [HubspotEnrichmentJobStatusEnum.ROLLBACK_FAILED]: 'Rollback Failed',
  [HubspotEnrichmentJobStatusEnum.CANCELLED]: 'Cancelled',
};
